var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"email-body-nav list-unstyled d-flex flex-column align-items-center p-4"},[_c('email-body-nav-link',{attrs:{"isActive":true}}),_vm._v(" "),_c('email-body-nav-link'),_vm._v(" "),_c('email-body-nav-link'),_vm._v(" "),_c('email-body-nav-link')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }